module.exports = __webpack_public_path__ + "images/logo/hikakaku_logo_small_30e7d9add07799750731d986c69f1330.png";